import { RxDocumentData } from 'rxdb';

import { Crumbs } from './Crumbs';

export const excludedProperties = ['_attachments', '_rev', '_meta'];

export function crumbleRxDocumentData(document: RxDocumentData<unknown>): Crumbs {
  return Object.entries(document).reduce((state, [key, value]) => {
    if (excludedProperties.includes(key)) return state;
    // `state` is explicitly for mutating.
    // eslint-disable-next-line no-param-reassign
    state[key] = JSON.stringify(value);
    return state;
  }, {} as Crumbs);
}
